import './styles.styl'
import 'react-toggle/style.css'

import React from 'react'
import Toggle from 'react-toggle'
import { Select } from 'antd'
import { locales } from '../../../locale-codes'

const NONE = 'NONE'
const ILOYALTY_STORE = 'ILOYALTY_STORE'
const IBRANDSTORE = 'IBRANDSTORE'
const ACTIEPAGINA = 'ACTIEPAGINA'
const API = 'API'
const SSTORE = 'S-STORE'

export default class SettingsBasic extends React.Component {
  constructor (props) {
    super(props)

    this.currencies = [
      [
        'Europe',
        'EUR € (Euro)',
        'GBP £ (Pounds)',
        'DKK kr (Kroner)',
        'SEK kr (Kronor)',
        'CHF CHF (Switzerland Francs)',
        'BGN лв (Leva)',
        'HRK kn (Kuna)',
        'CZK Kč (Koruny)',
        'HUF Ft (Forint)',
        'PLN zł (Zlotych)',
        'RON lei (New Lei)',
      ],
      [
        'World',
        'USD $ (Dollars)',
        'ALL Lek (Leke)',
        'AFN ؋ (Afghanis)',
        'ARS $ (Pesos)',
        'AWG ƒ (Guilders)',
        'AUD $ (Dollars)',
        'AZN ман (New Manats)',
        'BSD $ (Dollars)',
        'BBD $ (Dollars)',
        'BYR p. (Rubles)',
        'BZD BZ$ (Dollars)',
        'BMD $ (Dollars)',
        'BOB $b (Bolivianos)',
        'BAM KM (Convertible Marka)',
        'BWP P (Pula)',
        'BRL R$ (Reais)',
        'BND $ (Dollars)',
        'KHR ៛ (Riels)',
        'CAD $ (Dollars)',
        'KYD $ (Dollars)',
        'CLP $ (Pesos)',
        'CNY ¥ (Yuan Renminbi)',
        'COP $ (Pesos)',
        'CRC ₡ (Colón)',
        'CUP ₱ (Pesos)',
        'DOP RD$ (Pesos)',
        'XCD $ (Dollars)',
        'EGP £ (Pounds)',
        'SVC $ (Colones)',
        'FKP £ (Pounds)',
        'FJD $ (Dollars)',
        'GHC ¢ (Cedis)',
        'GIP £ (Pounds)',
        'GTQ Q (Quetzales)',
        'GGP £ (Pounds)',
        'GYD $ (Dollars)',
        'HNL L (Lempiras)',
        'HKD $ (Dollars)',
        'ISK kr (Kronur)',
        'INR Rp (Rupees)',
        'IDR Rp (Rupiahs)',
        'IRR ﷼ (Rials)',
        'IMP £ (Pounds)',
        'ILS ₪ (New Shekels)',
        'JMD J$ (Dollars)',
        'JPY ¥ (Yen)',
        'JEP £ (Pounds)',
        'KZT лв (Tenge)',
        'KPW ₩ (Won)',
        'KRW ₩ (Won)',
        'KGS лв (Soms)',
        'LAK ₭ (Kips)',
        'LVL Ls (Lati)',
        'LBP £ (Pounds)',
        'LRD $ (Dollars)',
        'LTL Lt (Litai)',
        'MKD ден (Denars)',
        'MYR RM (Ringgits)',
        'MUR ₨ (Rupees)',
        'MXN $ (Pesos)',
        'MNT ₮ (Tugriks)',
        'MZN MT (Meticais)',
        'NAD $ (Dollars)',
        'NPR ₨ (Rupees)',
        'ANG ƒ (Guilders)',
        'NZD $ (Dollars)',
        'NIO C$ (Cordobas)',
        'NGN ₦ (Nairas)',
        'NOK kr (Krone)',
        'OMR ﷼ (Rials)',
        'PKR ₨ (Rupees)',
        'PAB B/. (Balboa)',
        'PYG Gs (Guarani)',
        'PEN S/. (Nuevos Soles)',
        'PHP Php (Pesos)',
        'QAR ﷼ (Rials)',
        'RUB руб (Rubles)',
        'SHP £ (Pounds)',
        'SAR ﷼ (Riyals)',
        'RSD Дин. (Dinars)',
        'SCR ₨ (Rupees)',
        'SGD $ (Dollars)',
        'SBD $ (Dollars)',
        'SOS S (Shillings)',
        'ZAR R (Rand)',
        'LKR ₨ (Rupees)',
        'SRD $ (Dollars)',
        'SYP £ (Pounds)',
        'TWD NT$ (New Dollars)',
        'THB ฿ (Baht)',
        'TTD TT$ (Dollars)',
        'TRY TL (Lira)',
        'TRL £ (Liras)',
        'TVD $ (Dollars)',
        'UAH ₴ (Hryvnia)',
        'UYU $U (Pesos)',
        'UZS лв (Sums)',
        'VEF Bs (Bolivares Fuertes)',
        'VND ₫ (Dong)',
        'YER ﷼ (Rials)',
        'ZWD Z$ (Zimbabwe Dollars)'
      ]
    ]
    
    this.numberFormats = [
      '0,00',
      '0.00'
    ]

    let state = {
      customerId: '',
      projectName: '',
      domainName: '',
      domains: props.domains || [],
      isBeta: true,
      isHidden: false,
      storeType: NONE,
      maintenanceMode: false,
      maintenanceModeText: 'Wegens onderhoud is de webshop tijdelijk niet bereikbaar. Onze excuses voor het ongemak.',
      reportEmailsRecipient: '',
      currency: this.currencies[0][1],
      numberFormat: this.numberFormats[0],
      primaryLanguage: 'nl',
      secondaryLanguages: [],
    }

    if (props.data !== null) {
      state = {
        ...state,
        ...props.data,
        domains: [],
        isBeta: false,
        isHidden: false
      }

      if (props.hasOwnProperty('domains') && Array.isArray(props.domains)) {
        state.domains = props.domains
      }

      if (props.data.hasOwnProperty('status') && props.data.status === 'beta') {
        state.isBeta = true
      }

      if (props.data.hasOwnProperty('status') && props.data.status === 'hidden') {
        state.isHidden = true
      }
    }

    this.state = state

    this.handleSecondaryLanguageChange = (secondaryLanguages) => {
      this.setState({ secondaryLanguages })
    }
  }

  slugify (text) {
    return String(text)
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  saveAndToggle (index) {
    this.props.save({ ...this.state })
    this.props.toggleSection(index)
  }

  saveAndNext (index) {
    this.props.save({ ...this.state })
    this.props.nextSection(index)
  }

  render () {
    const index = this.props.index
    const {
      isBeta,
      isHidden
    } = this.state

    return (
      <section key={index} className={['section', (this.props.open ? 'section-open' : 'section-closed')].join(' ')}>
        <div className='row section-title'>
          <div className='col-10'>
            <h3>Basisinstellingen</h3>
          </div>

          <div className='col-2 text-align-right'>
            <a href='#' onClick={() => this.saveAndToggle(index)} className='edit-link'>{this.props.open ? 'Sluiten' : 'Bewerken'}</a>
          </div>
        </div>

        <div className='row section-content'>
          <div className='col-12 col-lg-10'>
            <div key={0} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Klant</label>
              </div>

              <div className='col-12 col-sm-8'>
                <select className='form-control' onChange={e => this.setState({ customerId: e.target.value })} value={this.state.customerId}>
                  {this.props.customers.map(customer => {
                    return <option value={customer.id} key={customer.id}>{customer.name}</option>
                  })}
                </select>
              </div>
            </div>

            <div key={1} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Projectnaam</label>
              </div>

              <div className='col-12 col-sm-8'>
                <input
                  type='text'
                  value={this.state.projectName}
                  onChange={e => this.setState({ projectName: e.target.value })}
                  className='form-control form-control-sm'
                  placeholder='Typ de naam van het project...'
                />
              </div>
            </div>

            <div key={2} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Domeinnaam</label>
              </div>

              <div className='col-12 col-sm-8'>
                {(isBeta === true || isHidden === true) && (<input
                  type='text'
                  value={this.state.domainName}
                  disabled
                  className='form-control form-control-sm'
                  placeholder={`Typ de FQDN van dit project${this.state.projectName === '' ? '' : `, e.g. "${this.slugify(this.state.projectName)}.iloyalty.io"`}...`}
                />)}

                {Array.isArray(this.state.domains) && (
                  this.state.domains.map((domain, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <input
                        type='text'
                        style={{ marginTop: '0.25em', width: '95%' }}
                        value={this.state.domains[index]}
                        onChange={e => this.setState({
                          domains: [ ...this.state.domains.slice(0, index), e.target.value, ...this.state.domains.slice(index + 1) ]
                        })}
                        disabled={isBeta === true || isHidden === true}
                        className='form-control form-control-sm'
                        placeholder={`Typ de FQDN van dit project${this.state.projectName === '' ? '' : `, e.g. "${this.slugify(this.state.projectName)}.iloyalty.io"`}...`}
                      />
                      <a style={{ display: 'block', width: '5%', textAlign: 'center' }} onClick={() => {
                        this.setState({
                          domains: [ ...this.state.domains.slice(0, index), ...this.state.domains.slice(index + 1) ]
                        })
                      }}>&times;</a>
                    </div>
                  ))
                )}

                {Array.isArray(this.state.domains) && (isBeta !== true && isHidden !== true) && (
                  <a style={{ display: 'inline-block', lineHeight: 2 }} onClick={() => {
                    this.setState({
                      domains: [ ...this.state.domains, '' ]
                    })
                  }}>+ FQDN toevoegen</a>
                )}
              </div>
            </div>

            <div key={3} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>E-mailadres rapportages</label>
              </div>

              <div className='col-12 col-sm-8'>
                <input
                  type='text'
                  value={this.state.reportEmailsRecipient}
                  onChange={e => this.setState({ reportEmailsRecipient: e.target.value })}
                  className='form-control form-control-sm'
                  placeholder={`Vul één of meerder e-mailadressen in, gescheiden door komma's.`}
                />
              </div>
            </div>

            <div key={4} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Adres klantenservice</label>
              </div>

              <div className='col-12 col-sm-8'>
                <input
                  key={0}
                  type='text'
                  value={this.state.address1}
                  onChange={e => this.setState({ address1: e.target.value })}
                  className='form-control form-control-sm form-control-margin'
                  placeholder='Adres'
                />
                <input
                  key={1}
                  type='text'
                  value={this.state.address2}
                  onChange={e => this.setState({ address2: e.target.value })}
                  className='form-control form-control-sm form-control-margin'
                  placeholder='Adres (regel 2)'
                />
                <input
                  key={2}
                  type='text'
                  value={this.state.postcode}
                  onChange={e => this.setState({ postcode: e.target.value })}
                  className='form-control form-control-sm form-control-margin'
                  placeholder='Postcode'
                />
                <input
                  key={3}
                  type='text'
                  value={this.state.city}
                  onChange={e => this.setState({ city: e.target.value })}
                  className='form-control form-control-sm form-control-margin'
                  placeholder='Plaats'
                />
                <input
                  key={4}
                  type='text'
                  value={this.state.email}
                  onChange={e => this.setState({ email: e.target.value })}
                  className='form-control form-control-sm form-control-margin'
                  placeholder='E-mailadres'
                />
                <input
                  key={5}
                  type='text'
                  value={this.state.phone}
                  onChange={e => this.setState({ phone: e.target.value })}
                  className='form-control form-control-sm form-control-margin'
                  placeholder='Telefoonnummer'
                />
              </div>
            </div>

            <div key={5} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Valuta</label>
              </div>

              <div className='col-12 col-sm-8'>
                <div className='form-group'>
                  <label className='form-label'>Valuta</label>
                  <select className='form-control' onChange={e => this.setState({ currency: e.target.value })} value={this.state.currency}>
                    {this.currencies.map(group => {
                      return (
                        <optgroup key={group[0]} label={group[0]}>
                          {group.slice(1).map(c => <option key={c} value={c}>{c}</option>)}
                        </optgroup>
                      )
                    })}
                  </select>
                </div>

                <div className='form-group'>
                  <label className='form-label'>Notatie</label>
                  <select className='form-control' onChange={e => this.setState({ numberFormat: e.target.value })} value={this.state.numberFormat}>
                    {this.numberFormats.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
              </div>
            </div>

            <div key={6} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Instellingen</label>
              </div>

              <div className='col-12 col-sm-8'>
                <div key={0} className='toggle-switch'>
                  <Toggle
                    checked={this.state.maintenanceMode}
                    onChange={e => this.setState({ maintenanceMode: e.target.checked })}
                  />
                  <span>Onderhoudsmodus actief</span>
                </div>

                <div key={1} className='toggle-switch'>
                  <Toggle
                    checked={(this.state.storeType === SSTORE)}
                    onChange={e => this.setState({ storeType: (e.target.checked === true ? SSTORE : '') })}
                  />
                  <span>S-Store</span>
                </div>

                <div key={2} className='toggle-switch'>
                  <Toggle
                    checked={(this.state.storeType === ILOYALTY_STORE)}
                    onChange={e => this.setState({ storeType: (e.target.checked === true ? ILOYALTY_STORE : '') })}
                  />
                  <span>L-Store (voorheen: iLoyalty Store)</span>
                </div>

                <div key={3} className='toggle-switch'>
                  <Toggle
                    checked={(this.state.storeType === IBRANDSTORE)}
                    onChange={e => this.setState({ storeType: (e.target.checked === true ? IBRANDSTORE : '') })}
                  />
                  <span>B-Store (voorheen: iBrandstore)</span>
                </div>

                <div key={4} className='toggle-switch'>
                  <Toggle
                    checked={(this.state.storeType === ACTIEPAGINA)}
                    onChange={e => this.setState({ storeType: (e.target.checked === true ? ACTIEPAGINA : '') })}
                  />
                  <span>Actiepagina</span>
                </div>

                <div key={5} className='toggle-switch'>
                  <Toggle
                    checked={(this.state.storeType === API)}
                    onChange={e => this.setState({ storeType: (e.target.checked === true ? API : '') })}
                  />
                  <span>API</span>
                </div>
              </div>
            </div>

            {this.state.maintenanceMode === true ? <div key={5} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Tekst onderhoudsmodus</label>
              </div>
              <div className='col-12 col-sm-8'>
                <textarea className='form-control' rows='5' onChange={e => this.setState({ maintenanceModeText: e.target.value })}>{this.state.maintenanceModeText}</textarea>
              </div>
            </div> : null}

            <div key={7} className='row subsection'>
              <div className='col-12 col-sm-4'>
                <label className='form-label'>Taal</label>
              </div>

              <div className='col-12 col-sm-8'>
                <div className='form-group'>
                  <label>Primaire taal</label>
                  <select className='form-control' onChange={e => this.setState({ primaryLanguage: e.target.value })} value={this.state.primaryLanguage}>
                    {(Array.isArray(locales) ? locales : []).map((loc) => {
                      if (loc.tag.length === 2) {
                        return <option key={loc.tag} value={loc.tag}>{loc.name}</option>
                      }

                      return null
                    })}
                  </select>
                </div>

                <br />
                <label>Aanvullende talen</label>
                <Select
                  mode='multiple'
                  placeholder='Kies één of meerdere talen...'
                  style={{ width: '100%' }}
                  value={this.state.secondaryLanguages}
                  onChange={this.handleSecondaryLanguageChange}
                >
                  {(Array.isArray(locales) ? locales : []).map((loc) => {
                    if (loc.tag.length === 2) {
                      return <Select.Option key={loc.tag} value={loc.tag}>{loc.name}</Select.Option>
                    }

                    return null
                  })}
                </Select>
              </div>
            </div>
          </div>
        </div>

        <div className='row section-buttons'>
          <div className='col-12 text-align-right'>
            <button className='btn btn-sm btn-secondary btn-rounded' onClick={() => this.saveAndNext(index)}>Volgende &raquo;</button>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/projects/create/settings-basic.js